/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Planshare_NoneInputs */

const en_us2_planshare_none = /** @type {(inputs: Planshare_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No active code. A code you turn off stops working at once.`)
};

const pt_br2_planshare_none = /** @type {(inputs: Planshare_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum código ativo. Um código desativado para de funcionar na hora.`)
};

const pt_pt2_planshare_none = /** @type {(inputs: Planshare_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhum código ativo. Um código desativado para de funcionar na hora.`)
};

/** @type {(inputs: Planshare_NoneInputs) => LocalizedString} */
const es_419_planshare_none = en_us2_planshare_none;

/** @type {(inputs: Planshare_NoneInputs) => LocalizedString} */
const fr_fr2_planshare_none = en_us2_planshare_none;

/** @type {(inputs: Planshare_NoneInputs) => LocalizedString} */
const de_de2_planshare_none = en_us2_planshare_none;

/** @type {(inputs: Planshare_NoneInputs) => LocalizedString} */
const it_it2_planshare_none = en_us2_planshare_none;

/**
* | output |
* | --- |
* | "No active code. A code you turn off stops working at once." |
*
* @param {Planshare_NoneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const planshare_none = /** @type {((inputs?: Planshare_NoneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Planshare_NoneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_planshare_none(inputs)
	if (locale === "es-419") return es_419_planshare_none(inputs)
	if (locale === "pt-PT") return pt_pt2_planshare_none(inputs)
	if (locale === "fr-FR") return fr_fr2_planshare_none(inputs)
	if (locale === "de-DE") return de_de2_planshare_none(inputs)
	if (locale === "it-IT") return it_it2_planshare_none(inputs)
	return en_us2_planshare_none(inputs)
});
export { planshare_none as "planshare.none" }